const CSS_CLASS_PREFIX = ".";
export const DEFAULT_PAGE_LAYOUT_CLASS_NAME = "sw-layout-page";
